const profile_pt = require('./profile.json')
export default profile_pt